(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mimora-customer-moments"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(scope=document){scope.querySelectorAll('[data-mm-moments]').forEach(root=>{
 if(root.dataset.momentsReady)return;root.dataset.momentsReady='true';
 const track=root.querySelector('.mm-customer-track'),cards=[...root.querySelectorAll('.mm-customer-moment')],dots=[...root.querySelectorAll('[data-mm-moment-dot]')];
 if(!track||!cards.length)return;
 const update=()=>{
  const overflow=track.scrollWidth>track.clientWidth+3;
  root.querySelector('.mm-moment-dots').hidden=!overflow;
  if(!overflow)return;
  let nearest=0,distance=Infinity;const center=track.getBoundingClientRect().left+track.clientWidth/2;
  cards.forEach((card,i)=>{const rect=card.getBoundingClientRect(),delta=Math.abs(rect.left+rect.width/2-center);if(delta<distance){distance=delta;nearest=i}});
  dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===nearest)));
 };
 dots.forEach((dot,i)=>dot.addEventListener('click',()=>{
  const tr=track.getBoundingClientRect(),cr=cards[i].getBoundingClientRect();
  track.scrollTo({left:track.scrollLeft+cr.left-tr.left-(track.clientWidth-cr.width)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 }));
 track.addEventListener('scroll',update,{passive:true});
 const observer=new ResizeObserver(update);observer.observe(track);
 root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
 update();
})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
